// extracted by mini-css-extract-plugin
export default {"started_head":"GetStarted_started_head__NL+Bo"};